export default __webpack_public_path__ + "static/media/badge.6144e520.png";